import { Global, Collection, Jobs } from '@sourceflow-uk/sourceflow-sdk';
import SeoHead from '../../components/SeoHead';
import Link from "next/link"
import MainBanner from '../../components/MainBanner';
import LatestJobs from '../../components/LatestJobs';
import NewSimpleContent from '../../components/NewSimpleContent';
import NewImageWithText from '../../components/NewImageWithText';
import AccordionColumnBox from '../../components/AccordionColumnBox';
import FeaturedEmployersImageWithText from '../../components/FeaturedEmployersImageWithText';
import AllJobSearch from '../../components/AllJobSearch';
import NewSubBanner from '../../components/NewSubBanner';
import NewColumnTextWithForm from '@/components/NewColumnTextWithForm';
import { Container } from 'reactstrap';
import { DynamicPageSeo } from "@/ui/DynamicPageSeo";
import { ContentBlocks } from "@/ui/ContentBlocks";

export default function JobSeekersIndividualPage({
    isBuilder,
    title,
    seo,
    canonical,
    data,
    prefix,
    global,
    page,
    client_cat_value,
    all_jobs,
    all_featured_employers_accordion_cards
}) {

    return (
        isBuilder ? (
            <>
                <DynamicPageSeo
                    {...seo}
                    title={seo?.title.length > 0 ? seo.title : title}
                    canonical={seo?.canonical.length > 0 ? seo.canonical : canonical}
                />
                <ContentBlocks data={data} prefix={prefix} />
            </>
        ) : (
            <>
                <SeoHead
                    page_name={`${page.title} | Project engineering and technical recruitment specialists | Carbon60`}
                    canonical_link={`job-seekers/${page.url_slug}`}
                />
                {page.new_template_v2 ?
                    <>
                        <NewSubBanner
                            global={global}
                            pathPrefix={`job_seekers.${page.url_slug}.new_sub_banner`}
                            customClass={``}
                            content={
                                <>
                                    <h1>{page.title}</h1>
                                </>
                            }
                            imageURL1={`/site-assets/images/main-banner.jpg`}
                            imageALT1={`Main Banner`}
                            imageURL2={`/site-assets/images/banner.webp`}
                            imageALT2={`Overlay Main Banner`}
                            displayImage1={false}
                            editableContent={false}
                            buttonLink={`/job-seekers/featured-employers`}
                            buttonTitle={`Back to Featured Employers`}
                            post={page}
                            featured_logo={true}
                            featured_employers_job_cta={true}
                        />
                        <NewImageWithText
                            global={global}
                            pathPrefix={`job_seekers.${page.url_slug}.new_image_with_text`}
                            post={page.image_with_text}
                            customClass={`py-5`}
                        />
                        {page?.new_left_column_content && (
                            <NewSimpleContent
                                global={global}
                                pathPrefix={`job_seekers.${page.url_slug}.new_simple_content.1`}
                                customClass={`py-5`}
                                content={
                                    page?.new_left_column_content
                                }
                                content_2={
                                    page?.new_right_column_content
                                }
                                dual_column={true}
                                border_bottom={true}
                                editableDualText={false}
                            />
                        )}
                        {page.new_centered_content && (
                            <NewSimpleContent
                                global={global}
                                pathPrefix={`job_seekers.${page.url_slug}.new_simple_content.2`}
                                customClass={`pb-5 text-center`}
                                content={
                                    page?.new_centered_content
                                }
                                editableText={false}
                            />
                        )}
                        {all_featured_employers_accordion_cards?.length >= 1 && (
                            <>
                                <Container>
                                    <hr />
                                </Container>
                                <AccordionColumnBox
                                    global={global}
                                    pathPrefix={`job_seekers.${page.url_slug}.new_accordion_card`}
                                    customClass={`py-5`}
                                    content={
                                        <>
                                            <h2>Title goes here</h2>
                                        </>
                                    }
                                    post={all_featured_employers_accordion_cards}
                                />
                            </>
                        )}
                        {all_jobs?.length >= 1 && (
                            <LatestJobs
                                global={global}
                                pathPrefix={`job_seekers.${page.url_slug}.latest_jobs`}
                                customClass={`py-5`}
                                post={all_jobs}
                                content={<>
                                    <h2>Jobs from {page.title}</h2>
                                    <p>Find the best tech and digital career opportunities.</p>
                                </>
                                }
                                buttonTitle={`View All Jobs`}
                                buttonLink={`/jobs#/${page.url_slug.replace(/-$/, '')}`}
                                swiperID={`latestJobsSwiper`}
                                locale={`/`}
                            />
                        )}
                        <Container>
                            <hr></hr>
                        </Container>
                        <NewColumnTextWithForm
                            global={global}
                            pathPrefix={`job_seekers.${page.url_slug}.new_column_text_with_form`}
                            content={
                                <>
                                    <h2>Contact Us Today</h2><p>If you are interested in working with one of our featured employers, complete the form and find out how we can help you.</p>
                                </>
                            }
                            formId={`1da9d36f-b1c6-4512-b3fe-e7a1d09a309b`}
                            customClass='py-5'
                            locale=""
                        />
                    </> :
                    <>
                        <MainBanner
                            global={global}
                            pathPrefix={`job_seekers.featured_employers_page.${page.url_slug}.main_banner`}
                            customClass={`${page.logo_image ? "featured-employer" : "no-image"}`}
                            content={
                                <>
                                    <h1 className='mb-4'>{page?.title}</h1>
                                    {page?.banner_content ?
                                        <div className="post-content" dangerouslySetInnerHTML={{ __html: page?.banner_content }} />
                                        : ""}
                                    {page?.banner_button_new_tab ?
                                        <Link href={`${page?.banner_button_link}`}>
                                            <a className='primaryBtn no-arrow' target="_blank" rel="noreferrer noopener">
                                                {page?.banner_button_title}
                                            </a>
                                        </Link> :
                                        <>
                                            {page?.banner_button_link ?
                                                <Link href={`${page?.banner_button_link}`}>
                                                    <a className='primaryBtn no-arrow'>
                                                        {page?.banner_button_title}
                                                    </a>
                                                </Link> : null}
                                        </>
                                    }
                                </>
                            }
                            imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                            imageALT2={`Overlay Main Banner`}
                            displayImage1={true}
                            editableContent={false}
                            imageURL1={`${page.logo_image ? page.logo_image : ""}`}
                            imageALT1={`${page.title}`}
                        />
                        <FeaturedEmployersImageWithText
                            global={global}
                            pathPrefix={`job_seekers.featured_employers_page.${page.url_slug}.featured_employers_with_with_text`}
                            customClass={`py-5`}
                            post={page?.image_with_text}
                            secondary_post={page?.roles}
                            pageButtonLink={`/job-seekers/featured-employers/`}
                            pageButtonTitle={`Back to featured employers`}
                        />
                        <AllJobSearch
                            global={global}
                            pathPrefix={`job_seekers_page.featured_employers_page.all_job_search`}
                            sectionID={`all-client-jobs`}
                            customClass={`py-5 grayGradientBg position-relative client-jobs`}
                            newsletter_content={
                                <>
                                    <h2>Subscribe to our newsletter</h2>
                                    <p>up to date with Carbon60</p>
                                </>
                            }
                            formId={`72b560ff-af77-4318-8b3c-5e0ed47ec955`}
                            successPageUrl={'/us/jobs/subscription-success/'}
                            jobClientFilter={true}
                            client_cat_value={client_cat_value}
                            uk_jobs={true}
                        />
                    </>
                }
            </>
        )
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();
    const page = (await Collection('featured_employers')).getJsonItem(params.url_slug, 'url_slug');

    if (!page) {
        return { notFound: true };
    }

    const all_jobs = (await Jobs())
        .filter(function (job) {
            return (
                job.categories
                    // Pulls Sectors only
                    .find((cat) => cat.id === "902834a4-3efa-4ad1-98b4-ebdf7755cdbe" && cat.values.find((x) => x.id === `${page.id}`))
            );
        })
        .filter(function (job) {
            return (
                (new Date(job?.expires_at)) >= (new Date())
            )
        })
        .getItems().slice(0, 8);

    const featured_employers_accordion_cards = await Collection('featured_employers_accordion_cards');
    const all_featured_employers_accordion_cards = featured_employers_accordion_cards.orderBy('featured_employers_accordion_cards').getItems();

    const client_cat_value = page.id;

    return {
        props: {
            global,
            page,
            all_jobs,
            client_cat_value,
            all_featured_employers_accordion_cards
        }
    };
}

export async function getStaticPaths() {
    const pagePath = (await Collection('featured_employers')).getPaths('url_slug');
    return {
        paths: pagePath,
        fallback: 'blocking'
    }
}
